import createAxios from './axiosHttp';

function getOrdersBack(pagination,filters) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.paid) {
        urlPath += `&with_paid=${true}`;
    }
    if (filters && filters.noPaid) {
        urlPath += `&with_paid=${false}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    return axios.get(urlPath);
}
function getOrderBackById(id){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${id}`;
    return axios.get(urlPath);
}
function getOrdersBackAsExcel(filters, language) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${language}/report`;
    urlPath += `?page=0&limit=1000000`;
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.paid) {
        urlPath += `&with_paid=${true}`;
    }
    if (filters && filters.noPaid) {
        urlPath += `&with_paid=${false}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}
function getTracking(orderId) {
    const axios = createAxios();
    let urlPath = `order_back/${orderId}/tracking`;
    return axios.get(urlPath);
}

function getResources(orderBackId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${orderBackId}/resources`;
    return axios.get(urlPath);
}

function downloadResource(orderBackId, fileName){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${orderBackId}/resources?filename=${fileName}`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function payOrRevert(body, entityId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${entityId}/pay`;
    return axios.post(urlPath, body);
}

function onHoldStatus(body, entityId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${entityId}/onHold`;
    return axios.put(urlPath, body);
}

function cancel(entityId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${entityId}`;
    return axios.delete(urlPath);
}

function recover(entityId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order_back/${entityId}/recover`;
    return axios.put(urlPath);
}

export const ordersBackService = { getOrdersBack,getOrderBackById,getOrdersBackAsExcel,getTracking, getResources, downloadResource, payOrRevert, onHoldStatus, cancel, recover };